import { cn } from "@/lib/utils";

export interface SegmentedOption<T extends string = string> {
    v: T;
    l: React.ReactNode;
}

interface SegmentedProps<T extends string> {
    options: SegmentedOption<T>[];
    value: T;
    onChange: (v: T) => void;
    className?: string;
}

export function Segmented<T extends string>({
    options,
    value,
    onChange,
    className,
}: SegmentedProps<T>) {
    return (
        <div
            className={cn(
                "inline-flex items-center gap-0.5 bg-gray-100 rounded-lg p-0.5",
                className
            )}
        >
            {options.map((o) => (
                <button
                    key={String(o.v)}
                    type="button"
                    onClick={() => onChange(o.v)}
                    className={cn(
                        "px-3 py-1 text-xs font-medium rounded-md transition-colors",
                        value === o.v
                            ? "bg-white text-gray-900 shadow-sm"
                            : "text-gray-600 hover:text-gray-900"
                    )}
                >
                    {o.l}
                </button>
            ))}
        </div>
    );
}
